<template>
    <form-container v-if="dataObject" headerText="Streaming Konsole" breakpoint="smAndDown"
                    :width="600" action="streamConsole" :valid-actions="['streamConsole']" @save="save()"
                    header-sub-text="Einstellung für die Ergebnisausgabe im Stream" button-cancel="zurück"
                    button-ok="Einstellungen speichern">
        <div class="px-6">
            <div class="subtitle-2 font-weight-bold mb-3">Links und IDs</div>
            <v-row>
                <v-col class="grow">
                    <v-text-field :value="dataObject.id" hide-details readonly
                                  outlined dense label="Spiel-ID">
                    </v-text-field>
                </v-col>
                <v-col class="shrink">
                    <v-btn icon @click="copyIdToClipboard(dataObject.id)">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="grow">
                    <v-text-field :value="urlTotal" hide-details readonly
                                  outlined dense label="Link für Anzeige Gesamtstand">
                    </v-text-field>
                </v-col>
                <v-col class="shrink">
                    <v-btn icon @click="copyIdToClipboard(urlTotal)">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="grow">
                    <v-text-field :value="urlDetail4" hide-details readonly
                                  outlined dense label="Link für Anzeige Durchgangsergebnis 4 Kameras">
                    </v-text-field>
                </v-col>
                <v-col class="shrink">
                    <v-btn icon @click="copyIdToClipboard(urlDetail4)">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="grow">
                    <v-text-field :value="urlDetail1or2" hide-details readonly
                                  outlined dense label="Link für Anzeige Durchgangsergebnis 1-2 Kameras">
                    </v-text-field>
                </v-col>
                <v-col class="shrink">
                    <v-btn icon @click="copyIdToClipboard(urlDetail1or2)">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <div class="subtitle-2 font-weight-bold mt-10 mb-3">Einstellungen Durchgangsergebnis</div>
            <v-row>
                <v-col class="py-2">
                    <v-switch v-model="stream.auto"  hide-details
                              label="vollautomatische Anzeige der Durchgänge
                              (Durchgänge und Bahnen wechseln jeweils 10 Sek. nach der Eingabe
                              und Speicherung der entsprechenden Kegelergebnisse)">
                    </v-switch>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pt-2 pb-0">
                    <v-radio-group v-model="stream.dg" row hide-details :disabled="stream.auto">
                        <v-radio v-for="n in numberOfDg" :key="n" class="mb-2"
                                 :label="`${n}. Durchgang`" :value="n" >
                        </v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-2 mb-10">
                    <v-checkbox v-model="stream.switch" hide-details :disabled="stream.auto"
                              label="Bahn innerhalb Durchgang wechseln (nach 2 Sätzen)">
                    </v-checkbox>
                </v-col>
            </v-row>
        </div>
        <v-snackbar v-model="snack.show" color="success">
            {{snack.text}}
        </v-snackbar>
    </form-container>
</template>

<script>
    import FormContainer from "../../../../components/form/formContainer";
    import {Spiel} from "../../../../services/data/spiel";

    export default {
        components: {FormContainer},
        props: ['currentData'],
        name: "stream-console",
        computed: {
            baseUrl() {
                return window.location.href.indexOf('Spielberichte?') !== -1 ?
                    window.location.href.split('Spielberichte?')[0] + 'Stream?id=' + this.dataObject.id :
                    window.location.href.split('SpielberichteFremd?')[0] + 'Stream?id=' + this.dataObject.id;
            },
            urlTotal(){
                return this.baseUrl + '&type=total'
            },
            urlDetail4(){
                return this.baseUrl + '&type=detail4'
            },
            urlDetail1or2(){
                return this.baseUrl + '&type=detail1or2'
            },
            numberOfDg(){
                return this.dataObject ? Object.keys(this.dataObject.partien).length / 2 : 3
            }
        },
        data: () => ({
            dataObject: null,
            snack: {
                show: false,
                text: '',
            },
            stream: {
                auto: true,
                dg: 1,
                switch: true,
            }
        }),
        created(){
            this.dataObject = new Spiel();
            this.dataObject.setFromDataObject(this.currentData);
            if ( this.currentData.stream ) {
                this.stream = this.currentData.stream;
            }
        },
        methods: {
            async save(){
                this.dataObject.local.documentUpdates = {
                    stream: this.stream,
                },
                this.$store.state.local.loader = true;
                let reply = await this.dataObject.saveEdited('spiel_edit');
                if ( reply.successful ) {
                    this.snack.show = true;
                    this.snack.text = 'Die Einstellungen wurden übernommen!';
                } else {
                    console.error ("Fehler beim Speichern", reply.content );
                }
                this.$store.state.local.loader = false;
            },
            copyIdToClipboard(data){
                navigator.clipboard.writeText(data);
                this.snack.show = true;
                this.snack.text = 'Die Daten wurden in die Zwischenablage kopiert!'
            },
        },
    }
</script>

<style scoped>

</style>